import type { PerUnitProduct, TiersProduct } from '@vy/services';
import { isPerUnitUsageProductOnly, isTieredSubscriptionUsageProductOnly, isTiersUsageProductOnly } from '@vy/services';
import type { UsageProduct, UsageProductInput } from '@vy/types';
import { raise, vySerialize } from '@vy/utils';
import React from 'react';
import { PerUnitUsageCharge } from './PerUnitUsageCharge/PerUnitUsageCharge';
import { PerUnitUsageChargeEdit } from './PerUnitUsageChargeEdit/PerUnitUsageChargeEdit';
import { TieredSubscriptionUsageCharge } from './TieredSubscriptionUsageCharge/TieredSubscriptionUsageCharge';
import { TieredSubscriptionUsageChargeEdit } from './TieredSubscriptionUsageChargeEdit/TieredSubscriptionUsageChargeEdit';
import { TiersUsageCharge } from './TiersUsageCharge';
import { TiersUsageChargeEdit } from './TiersUsageChargeEdit';

type UsageChargeProps = {
  product: UsageProduct | UsageProductInput;
  editable: boolean;
};

export const UsageCharge: React.FC<UsageChargeProps> = ({ product, editable }) => {
  const createUsageCharge = useUsageChargeFactory();

  return createUsageCharge(product, editable);
};

function useUsageChargeFactory() {
  return (product: UsageProduct | UsageProductInput, editable: boolean) => {
    if (isTiersUsageProductOnly<TiersProduct>(product)) {
      return editable ? <TiersUsageChargeEdit /> : <TiersUsageCharge />;
    }

    if (isPerUnitUsageProductOnly<PerUnitProduct>(product)) {
      return editable ? <PerUnitUsageChargeEdit /> : <PerUnitUsageCharge />;
    }

    if (isTieredSubscriptionUsageProductOnly(product)) {
      return editable ? (
        <TieredSubscriptionUsageChargeEdit />
      ) : (
        <TieredSubscriptionUsageCharge />
      );
    }

    return raise(`Unknown usage product type: ${vySerialize(product, null, 2)}`);
  };
}
